<template>
  <div class="games-table-row">
    <el-row type="flex" justify="center">
      <el-col :xs="{span: 24}" :sm="{span: 24}" class="game-table">
        <el-row type="flex" justify="left">

          <!-- Index-->
          <el-col :xs="{span: layout.index.xs}" :sm="{span: layout.index.sm}" v-if="layout.index.show" :class="layout.index.extendClass || ''">
            <el-row type="flex" justify="left" class="game-system-index">{{index}}</el-row>
          </el-col>

          <!-- Modified date-->
          <el-col :xs="{span: layout.modifiedDate.xs}" :sm="{span: layout.modifiedDate.sm}" v-if="layout.modifiedDate.show" :class="layout.modifiedDate.extendClass || ''">
            <el-row type="flex" justify="left" class="game-modified-date">{{moment((game.status || {}).modifiedDate || (game.status || {}).createdDate).fromNow()}}</el-row>
          </el-col>

          <!-- System avatar -->
          <el-col :xs="{span: layout.systemIcon.xs}" :sm="{span: layout.systemIcon.sm}" v-if="layout.systemIcon.show" :class="layout.systemIcon.extendClass || ''">
            <el-row type="flex" justify="left" ><img :src="systemIcons[game.systemAvatar]" class="game-system-icon"></el-row>
          </el-col>

          <!-- System short name -->
          <el-col :xs="{span: layout.systemShortName.xs}" :sm="{span: layout.systemShortName.sm}" v-if="layout.systemShortName.show" :class="layout.systemShortName.extendClass || ''">
            <el-row type="flex" justify="left" class="game-system-name">{{ systemShortName(game.systemSlug) }}</el-row>
          </el-col>

          <!-- Game avatar -->
          <el-col :xs="{span: layout.gameIcon.xs}" :sm="{span: layout.gameIcon.sm}" v-if="layout.gameIcon.show" :class="layout.gameIcon.extendClass || ''">
            <el-row type="flex" justify="left">
              <img class="game-icon" v-if="game.avatar && gameIcons[game.avatar]" :src="gameIcons[game.avatar]">
              <div v-else style="width:1px; height:1px;"></div>
            </el-row>
          </el-col>

          <!-- Game title -->
          <el-col :xs="{span: layout.gameTitle.xs}" :sm="{span: layout.gameTitle.sm}" v-if="layout.gameTitle.show" :class="layout.gameTitle.extendClass || ''">
            <el-row type="flex" justify="left" :class="'game-title ' + (game.status && game.status.finished ? 'game-title-finished' : '')">
              {{ game.title }}
            </el-row>
          </el-col>

          <!-- Game Tag -->
          <el-col :xs="{span: layout.gameTag.xs}" :sm="{span: layout.gameTag.sm}" v-if="layout.gameTag.show" :class="layout.gameTag.extendClass || ''">
            <game-tag-manageable v-if="manageGameTagEnabled" :game="game" :addStatus="addStatus"></game-tag-manageable>
            <game-tag-exploring v-else-if="exploringGameTagEnabled" :game="game" :addStatus="addStatus"></game-tag-exploring>
            <game-tag-info v-else :game="game" :addStatus="addStatus" :addGameEnabled="addGameEnabled"></game-tag-info>
          </el-col>
        </el-row>
      </el-col>
    </el-row>
  </div>
</template>

<script>
// @ is an alias to /src
import moment from 'moment'
import systemShortName from '@/utils/system-short-name.js'

import GameTagInfo from '@/components/game-tag-info'
import GameTagExploring from '@/components/game-tag-exploring'
import GameTagManageable from '@/components/game-tag-manageable'

export default {
  name: 'GamesTableRow',
  components: {
    GameTagInfo,
    GameTagManageable,
    GameTagExploring
  },
  props: {
    game: {
      type: Object,
      default: function () { return {} }
    },
    gameIcons: {
      type: Object,
      default: function () { return {} }
    },
    systemIcons: {
      type: Object,
      default: function () { return {} }
    },
    addStatus: {
      default: () => {}
    },
    index: {
      default: 1
    },
    addGameEnabled: {
      default: false
    },
    manageGameTagEnabled: {
      default: false
    },
    exploringGameTagEnabled: {
      default: false
    },
    options: {
      type: Object,
      default: function () {
        return {
          index: {
            show: false,
            xs: 0,
            sm: 0,
            md: 0,
            extendClass: ''
          },
          modifiedDate: {
            show: false,
            xs: 0,
            sm: 0,
            md: 0,
            extendClass: ''
          },
          systemIcon: {
            show: false,
            xs: 0,
            sm: 0,
            md: 0,
            extendClass: ''
          },
          systemShortName: {
            show: false,
            xs: 0,
            sm: 0,
            md: 0,
            extendClass: ''
          },
          gameIcon: {
            show: false,
            xs: 0,
            sm: 0,
            md: 0,
            extendClass: ''
          },
          gameTitle: {
            show: false,
            xs: 0,
            sm: 0,
            md: 0,
            extendClass: ''
          },
          gameTag: {
            show: false,
            xs: 0,
            sm: 0,
            md: 0,
            extendClass: ''
          }
        }
      }
    }
  },
  computed: {
    layout () {
      return {
        index: Object.assign({ show: false, xs: 0, sm: 0, md: 0, extendClass: '' }, this.options.index || {}),
        modifiedDate: Object.assign({ show: false, xs: 0, sm: 0, md: 0, extendClass: '' }, this.options.modifiedDate || {}),
        systemIcon: Object.assign({ show: false, xs: 0, sm: 0, md: 0, extendClass: '' }, this.options.systemIcon || {}),
        systemShortName: Object.assign({ show: false, xs: 0, sm: 0, md: 0, extendClass: '' }, this.options.systemShortName || {}),
        gameIcon: Object.assign({ show: false, xs: 0, sm: 0, md: 0, extendClass: '' }, this.options.gameIcon || {}),
        gameTitle: Object.assign({ show: false, xs: 0, sm: 0, md: 0, extendClass: '' }, this.options.gameTitle || {}),
        gameTag: Object.assign({ show: false, xs: 0, sm: 0, md: 0, extendClass: '' }, this.options.gameTag || {})
      }
    }
  },
  data () {
    return {}
  },
  mounted () {},
  methods: {
    moment,
    systemShortName,
    sort () {

    }
  }
}
</script>
<style lang="scss">
@import '../styles/variables.scss';

.games-table-row {
  padding-top: 5px;

  .game-title {
    padding-right: 5px;
    text-align: left;
    font-size: $font-size-regular;
    text-shadow: #d6d0b5 1px 0 10px;
    margin-top: -5px;
  }

  .game-title-finished {
    color: $main-color-2;
    text-shadow: #00ff4f 1px 0 10px;
  }

  .game-system-index {
    font-size: $font-size-regular;
  }
  .game-modified-date {
    font-size:$font-size-small-regular;
  }

  .game-system-icon {
    margin-top: -10px;
    max-width: 40px;
  }

  .game-system-name {
    text-align: left;
    vertical-align: middle;
    padding-right: 5px;
    overflow: hidden;
    font-size: $font-size-small;
    text-shadow: 1px 1px 2px black, 0 0 1em #ca4444, 0 0 0.2em #a6a6ad;
  }

  .game-icon {
    margin-bottom: 10px;
    width: 20px;
    height: 20px;
    margin-top: -5px;
  }

  @media screen and (max-width: 35em) {
    margin-bottom: 10px;

    .game-icon {
      margin-bottom: 10px;
      width: 20px;
      height: 20px;
      margin-top: -5px;
    }

    .game-status {
      margin-right: -10px;
    }

    .game-system-index {
      font-size:$font-size-small;
      margin-top: 3px;
    }

    .game-system-name {
      margin-top: 2px;
    }

    .game-title {
      margin-left: 5px;
    }
  }
}
</style>
